import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import clsx from 'clsx';
import { useMainTheme } from '@fuse/core/FuseSettings/hooks/fuseThemeHooks';
import useFuseSettings from '@fuse/core/FuseSettings/hooks/useFuseSettings';
import useUser from '@auth/useUser';
import { findThemePreset, getThemeSection, themePresets } from '@/configs/themePresets';

type LightDarkModeToggleProps = {
  className?: string;
};

function LightDarkModeToggle({ className = '' }: LightDarkModeToggleProps) {
  const { data: settings, setSettings } = useFuseSettings();
  const { isGuest, updateUserSettings } = useUser();
  const isDarkMode = useMainTheme().palette.mode === 'dark';

  const toggleTheme = async () => {
    const preset = findThemePreset(settings.theme) ?? themePresets[0];
    const theme = getThemeSection(preset, isDarkMode ? 'light' : 'dark');
    const newSettings = setSettings({ theme });

    try {
      const stored = JSON.parse(localStorage.getItem('settings') || '{}');
      localStorage.setItem('settings', JSON.stringify({ ...stored, theme }));
    } catch (error) {
      console.error('Failed to save theme:', error);
    }

    if (!isGuest) {
      try {
        await updateUserSettings(newSettings);
      } catch (error) {
        console.error('Failed to sync theme:', error);
      }
    }
  };

  return (
    <Tooltip title={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}>
      <IconButton onClick={toggleTheme} className={clsx('border border-divider', className)}>
        <FuseSvgIcon>{isDarkMode ? 'heroicons-outline:sun' : 'heroicons-outline:moon'}</FuseSvgIcon>
      </IconButton>
    </Tooltip>
  );
}

export default LightDarkModeToggle;
